"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spacing = void 0;
const layout_1 = require("@carbon/layout");
exports.spacing = Object.assign({ zero: (0, layout_1.rem)(0), one: (0, layout_1.rem)(1) }, layout_1.spacing.reduce((acc, space, index) => (Object.assign(Object.assign({}, acc), { [String(index + 1)]: space })), {}));
